import { useEffect, useState } from "react";
import * as d from "deepai"




const useSentimental = (TEXT) => {
    // const KEY =process.env.REACT_APP_DEEP_AI_API_KEY?process.env.REACT_APP_DEEP_AI_API_KEY:secrets.REACT_APP_DEEP_AI_API_KEY
    const KEY =process.env.REACT_APP_DEEP_AI_API_KEY
    const [mood,setMood] = useState(null);
    d.setApiKey(KEY);
    useEffect(async ()=>{
        if(TEXT){
        const  deep = await d.callStandardApi("sentiment-analysis", {
            text: TEXT,
    },[]
    );
        console.log(deep.output);
        setMood(deep.output[0])}
        }
    )

    return {mood};
}
 
export default useSentimental;